import React, {
  useState,
  createContext,
  useEffect,
  useMemo,
  useCallback,
} from 'react';

import Loader from '../components/FullScreenLoader';
import { SIDEBARSHOW } from '../constants/app';

export const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [sidebarShow, setSidebarShow] = useState('opened');
  const [navbarTogglerOpen, setNavbarTogglerOpen] = useState(true);

  const toggleSidebar = useCallback(() => {
    setSidebarShow((prevState) => {
      localStorage.setItem(SIDEBARSHOW, prevState === 'opened' ? 'closed' : 'opened');
      return prevState === 'opened' ? 'closed' : 'opened';
    });
  }, []);

  const minimizeSidebar = useCallback(() => {
    setSidebarShow(() => {
      localStorage.setItem(SIDEBARSHOW, 'minimized');
      return 'minimized';
    });
  }, []);

  useEffect(() => {
    setSidebarShow(localStorage.getItem(SIDEBARSHOW) || 'opened');
  }, []);

  const value = useMemo(
    () => ({
      sidebarShow,
      toggleSidebar,
      minimizeSidebar,
      navbarTogglerOpen,
      setNavbarTogglerOpen,
      setLoading,
    }),
    [sidebarShow, navbarTogglerOpen],
  );

  return (
    <AppContext.Provider value={value}>
      <Loader loading={loading} />
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
